import { forwardRef } from "react";

import {
  StepsContent,
  StepsIndicator,
  StepsList,
  StepsListItem,
  StepsRoot,
  StepsTrack,
  type StepsItems,
  type StepsRootProps,
  type StepsRootRef,
} from "./steps.components";
import { toAriaCurrent, toEdge, toVariant } from "./steps.utils";

export type StepsRef = StepsRootRef;

export interface StepsProps extends StepsRootProps {
  activeIndex?: number;
  items: StepsItems;
}

const Steps = forwardRef<StepsRef, StepsProps>(
  ({ activeIndex = 0, items, ...props }, ref) => {
    return (
      <StepsRoot {...props} ref={ref}>
        <StepsList>
          {items.map(({ id, children }, index) => {
            const ariaCurrent = toAriaCurrent(activeIndex, index);
            const variant = toVariant(activeIndex, index);
            const edge = toEdge(items.length, index);
            return (
              <StepsListItem id={id} aria-current={ariaCurrent} key={id}>
                <StepsTrack edge={edge} variant={variant} />
                <StepsIndicator variant={variant} />
                <StepsContent variant={variant}>{children}</StepsContent>
              </StepsListItem>
            );
          })}
        </StepsList>
      </StepsRoot>
    );
  },
);

Steps.displayName = "Steps";

export { Steps };
